import { CommunicationDetailsClient } from '@/api/communication/get-communication-details'
import { CommunicationHistoryItem } from '@/api/communication/get-communication-history'
import NewMessageForm from '@/components/Organisation/CommunicationPortal/NewMessageForm'
// TODO: Replace with a new TypeScript component once announcement details are refactored
import { CommunicationType, MailingListItem, PartialBy } from '@/models'
import { BuildingFilterItem } from '@/reducers/types'

type NewMessageFormPreviewData = PartialBy<Omit<CommunicationHistoryItem, 'attachments'>, 'id'> & {
  attachments?: ({ fileName: string } | File)[]
  // Note: From the communication details, to pre-select by name — the history item only has ids
  standaloneClients?: CommunicationDetailsClient[]
}

interface NewMessageFormModalProps {
  onClose: VoidFunction
  previewData?: NewMessageFormPreviewData | null
  type: CommunicationType | undefined
  mailingListOptions: Array<MailingListItem & { label: string }>
  selectedBuilding: BuildingFilterItem
  refreshTable: VoidFunction
  fetchAnnouncementDetails: VoidFunction
  isDuplicateAnnouncementFormActive?: boolean
}

export const NewMessageFormModal = ({
  onClose,
  previewData = null,
  isDuplicateAnnouncementFormActive = false,
  ...props
}: NewMessageFormModalProps) => {
  return (
    <NewMessageForm
      {...props}
      previewData={previewData}
      handleCancel={onClose}
      isDuplicateAnnouncementFormActive={isDuplicateAnnouncementFormActive}
    />
  )
}
